/**
 * When one tab gives up the OIDC session ({@see registerAuthSessionLostHandler}),
 * other tabs still hold tokens in React memory + their own sessionStorage user.
 * Setting this key fires a `storage` event so every tab can clear state consistently.
 */
export const AUTH_SESSION_INVALIDATED_STORAGE_KEY =
  'communo_auth_session_invalidated'

/** Best-effort: other tabs only see `storage` when the value changes. */
export function broadcastAuthSessionInvalidatedAcrossTabs(): void {
  try {
    const v = String(Date.now())
    localStorage.setItem(AUTH_SESSION_INVALIDATED_STORAGE_KEY, v)
  } catch {
    //
  }
}
